import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Card, Spinner, Alert } from 'react-bootstrap';
import $ from 'jquery';
import * as XLSX from 'xlsx'; 
import Header from '../Header';
import { useNavigate } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css"; 
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; 
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; 
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";

const Assignedtasks = () => {
  const [emp, setEmp] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const tableRef = useRef(null);
  const navigate = useNavigate();

  // Fetch employee data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/showtasks`);
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const result = await response.json();  
        setEmp(result.task || []);  
      console.log(result);
      } catch (error) {
        console.error("Error fetching data:", error); 
        setError(error.message);  
      } finally {
        setLoading(false);  
      }
    };

    fetchData(); 
  }, []);

  // Initialize DataTable after employee data is fetched
  useEffect(() => {
    if (emp.length > 0 && tableRef.current) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, 
        paging: true,
        pageLength: 10, 
        lengthMenu: [10, 25, 50, 100], 
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
          { targets: 4, responsivePriority: 5 },
          { targets: 5, responsivePriority: 6 },
          { targets: 6, responsivePriority: 7 },
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [emp]);

  const exportToExcel = () => {
    if (emp.length === 0) {
      alert("No data to export");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(emp);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "emp");

    XLSX.writeFile(wb, "Employee_List.xlsx");
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      <Header />
    
      <div className="shadow mx-1 px-3 bg-light rounded-3">
        <div className="d-flex align-items-center justify-content-between p-3 mt-3">
          <h4 className="mb-0">Assigned Task List</h4>
          <Button variant="success" onClick={exportToExcel}>
            Export to Excel
          </Button>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}

        <Card>
          <Card.Header>Task List</Card.Header>
          <Card.Body>
            <div className="table-responsive">
              <Table ref={tableRef} striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Task Id</th>
                    <th>User</th>
                    <th>Plan</th>
                    <th>Service Task</th>                    
                    <th>Description</th>
                    <th>Assigned To</th>
                    <th>Emp Remarks</th>
                    <th>Status</th>
                    <th>Assigned On</th>
                    <th>Closed On</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {emp.length > 0 ? (
                    emp.map((emp, index) => (
                      <tr key={emp.id}>
                        <td>{index + 1}</td>
                        <td className="text-danger">{emp.task_uniqueid || 'N/A'}</td>
                        <td className="text-primary">{emp.Username || 'N/A'}</td>
                        <td>{emp.Plan || 'N/A'}</td>
                        <td >{emp.Sname || 'N/A'}</td>
                        <td>{emp.Task_Description || 'N/A'}</td>
                        <td className="text-primary">{emp.EmpName || 'N/A'}</td>
                        <td>{emp.Emp_Description || 'N/A'}</td>
                        <td className={emp.status === 'closed' ? 'text-danger' : 'text-primary'}>
                            {emp.status || 'N/A'}
                        </td>
                        <td>{emp.doa || 'N/A'}</td>
                        <td>{emp.task_cdate || 'N/A'}</td>
                        <td>
                        <button className="btn btn-primary" onClick={() => navigate(`/Quries/${emp.task_uniqueid}`)}>
                              View
                          </button>
                        </td>  
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-center">No Tasks available</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default Assignedtasks;
